import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { GetSmsProvidersResponse } from '../../types'

function useQueryGetSMSProviders(
	props?: UseBaseQueryOptions<GetSmsProvidersResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetSMSProviders],
		queryFn: () => MessagingService.getSMSProviders(),
		...props,
	})
}

export default useQueryGetSMSProviders
